import { useEffect } from 'react';
import { useApi, discoveryApiRef } from '@backstage/core-plugin-api';
import type { IdentityApi, SignInPageProps } from '@backstage/core-plugin-api';

export const AutoSignIn = ({ onSignInSuccess }: SignInPageProps) => {
  const discoveryApi = useApi(discoveryApiRef);

  useEffect(() => {
    let cancelled = false;

    const signIn = async () => {
      const baseUrl = await discoveryApi.getBaseUrl('auth');
      const resp = await fetch(`${baseUrl}/guest/refresh`, { method: 'POST' });

      if (!resp.ok || cancelled) return;

      const data = await resp.json();
      let cachedToken: string | undefined = data.backstageIdentity?.token;
      let tokenExpiry =
        Date.now() +
        (data.backstageIdentity?.expiresInSeconds ?? 3600) * 1000 * 0.9;

      const refresh = async (): Promise<string | undefined> => {
        if (cachedToken && Date.now() < tokenExpiry) return cachedToken;
        const r = await fetch(
          `${await discoveryApi.getBaseUrl('auth')}/guest/refresh`,
          { method: 'POST' },
        );
        const d = await r.json();
        cachedToken = d.backstageIdentity?.token;
        tokenExpiry =
          Date.now() +
          (d.backstageIdentity?.expiresInSeconds ?? 3600) * 1000 * 0.9;
        return cachedToken;
      };

      const identityApi: IdentityApi = {
        async getBackstageIdentity() {
          await refresh();
          return {
            type: 'user' as const,
            userEntityRef: 'user:default/guest',
            ownershipEntityRefs: ['user:default/guest'],
          };
        },
        async getCredentials() {
          return { token: await refresh() };
        },
        async getProfileInfo() {
          return { displayName: 'Guest' };
        },
        async signOut() {},
      };

      if (!cancelled) onSignInSuccess(identityApi);
    };

    signIn();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
